import { createEntityStore, type EntityState, type EntityStore } from '@datorama/akita';
import { type CustomFilter } from 'types/models';

export type CustomUserFiltersState = EntityState<CustomFilter>;

const store: EntityStore<CustomUserFiltersState> = createEntityStore({}, { resettable: true, name: 'filters/custom' });

export default store;
